import { Suspense, useEffect, useState } from "react";
import { FORLoading, FORType } from "../../../db/model";
import { GetForDataAPI } from "../../../db/apiCalls";
import ForComponent from "./FOR/ForComponent";
import { toast } from "react-toastify";
import ErrorBoundary from "../../../ErrorBoundary";

export default function FabricOutwardRegister() {
  const [forData, setForData] = useState<FORType[]>(FORLoading);

  async function getForData() {
    let result = await GetForDataAPI();

    const data = result
      ? JSON.parse(result)
      : {
          statusCode: 0,
          message:
            "Something went wrong, Please check your internet connection.",
          success: false,
          fabricOutwards: [],
        };

    if (data.success) {
      let forarray: FORType[] = data.fabricOutwards;
      return forarray;
    } else {
      toast.error(
        `Error fetching FOR Data, ${data.statusCode} : ${data.message}`
      );
      return [];
    }
  }

  useEffect(() => {
    getForData().then((data) => {
      setForData(data);
    });
  }, []);

  return (
    <ErrorBoundary>
      <Suspense fallback={<h3>Loading...</h3>}>
        {/* <div className="text-end w-full sticky top-0">
          <Link
            to="/orders/new-order"
            className="bg-blue-600 text-white justify-center border-0 rounded-lg py-1 px-3"
          >
            <NoteAddIcon fontSize="small" className="mb-1 my-auto" /> Add
          </Link>
        </div> */}
        <ForComponent forData={forData} />
      </Suspense>
    </ErrorBoundary>
  );
}
